import { Component, OnInit, ViewChild, Inject, Input } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatTableDataSource, MatSort } from '@angular/material';
import { SelectionModel } from '@angular/cdk/collections';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { MatSnackBar } from '@angular/material';


@Component({
    selector: 'app-modal-feed',
    templateUrl: 'modal-feed.component.html',
    styleUrls: ['./userpanel.component.css'],
    providers: [  ]
  })
  export class ModalFeedComponent {

    constructor(public dialogRef: MatDialogRef<ModalFeedComponent>, @Inject(MAT_DIALOG_DATA) public data: any) {
    }

    image

    ngOnInit(){
        this.image = this.data.img
    }




  }



// WEBPACK FOOTER //
// ./src/app/shared/feed/modal-feed/modal-feed.component.ts